import {
  ImageScaleView,
  View,
  ViewOpts,
  animate,
} from '@play-co/timestep-core/ui';
import createIntervalEmitter, {
  IntervalEmitter,
} from 'src/lib/createIntervalEmitter';
import { bundleSaleTheme } from './match2-bundlesale.theme';

export class Match2BundleSaleSnow extends View {
  private snowflakes: ImageScaleView[] = [];
  private emitter: IntervalEmitter<{ now: number }>;
  private last!: number;

  constructor(opts: ViewOpts) {
    super({ ...opts });
    this.createSnowFlakes();
    this.emitter = createIntervalEmitter((_, now) => ({ now }), 1);
  }

  private createSnowFlakes() {
    const numSnowflakes = 100;
    for (let i = 0; i < numSnowflakes; i++) {
      const flake = new ImageScaleView({
        superview: this,
        image: bundleSaleTheme().getAsset('snowflake'),
        width: 12,
        height: 12,
        scale: Math.random() * 0.5 + 0.5,
        x: Math.random() * this.style.width,
        y: Math.random() * this.style.height,
        centerOnOrigin: true,
        ...bundleSaleTheme().getStyle('snowflake'),
      });
      this.snowflakes.push(flake);
    }
  }

  public start() {
    this.updateOpts({ opacity: 0 });
    animate(this).now({ opacity: 1 }, 500);
    this.emitter.addListener(this.updateBinded);
  }

  public stop() {
    animate(this).now({ opacity: 0 }, 500);
    this.emitter.removeListener(this.updateBinded);
  }

  private updateBinded = this.update.bind(this);

  private update({ now }: { now: number }) {
    if (!this.style.visible) return;
    if (!this.last) this.last = now;
    const dt = now - this.last;
    this.snowflakes.forEach((snowflake) => {
      snowflake.style.offsetX =
        Math.sin(now * 0.001 * snowflake.style.scale) * 20;
      snowflake.style.y += dt * 0.1 * snowflake.style.scale;
      if (snowflake.style.y > this.style.height + snowflake.style.height) {
        snowflake.updateOpts({
          x: Math.random() * this.style.width,
          y: -snowflake.style.height,
        });
      }
    });
    this.last = now;
  }
}
